<template>
    <div>
        <flash-error ref="flashError"></flash-error>
        <progress-bar percentages="30"></progress-bar>
        <section id="service-section" class="py-2 mobile-container">
            <div class="d-flex align-items-center justify-content-between text-light">
                <div>Services</div>
                <div>
                    <div class="info-box d-flex align-items-center justify-content-center cursor-pointer"
                         @click="openModalIframe"
                    >
                        <span class="material-symbols-outlined" style="font-size: 20px;">info_i</span>
                    </div>
                </div>
            </div>
        </section>
        <section id="text-section" class="mobile-container bg-light">
            <div class="py-2">
                <div class="mb-2">
                    <div class="mb-1">Nuværende valg:</div>
                    <div>Standard afhentning fra kantsten</div>
                    <div>
                        Afhentning mellem kl.
                        {{ getPickupTime(booking, 'start', configurations['default_time_from_pickup'].value) }} -
                        {{ getPickupTime(booking, 'end', configurations['default_time_to_pickup'].value) }}
                    </div>
                </div>
                <br>
                <div class="mb-2">
                    <div class="mb-1">Se mulige tilvalg:</div>
                    <div v-if="countdownVisible" class="alert alert-warning py-2 px-3 mb-2">
                        Der er <strong>{{ timeLeft }}</strong> tilbage, før priserne stiger til +{{ upcomingPercentage }}%.
                    </div>
                    <div v-for="(item, key) in additionalServices"
                         v-if="[additionalServiceShorterTimeInterval].includes(key)"
                    >
                        <div class="d-flex mb-1">
                            <input type="checkbox"
                                   :id="`additional-${key}`"
                                   v-model="item.enabled"
                            >
                            <label class="ml-2 mb-0" :for="`additional-${key}`">
                                {{ item.name }}
                            </label>
                        </div>
                        <div v-if="key === additionalServiceShorterTimeInterval && item.enabled"
                             class="mb-2"
                        >
                            <div class="align-items-center bg-white rounded-lg div-focus">
                                <select v-model="additionalServices[key].value"
                                        class="form-control"
                                        @change="onChangeShorterTimeInterval">
                                    <option value=""></option>
                                    <option v-for="interval in shorterTimeIntervals"
                                            :value="interval"
                                    >
                                        {{ interval.from }} - {{ interval.to }} ({{ displayPrice(interval.basePrice) }} kr.)
                                    </option>
                                </select>
                            </div>
                            <div class="text-danger" v-if="errors[additionalServiceShorterTimeInterval]">
                                {{ errors[additionalServiceShorterTimeInterval] }}
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <div>
                    <button class="btn btn-success" @click="goNext">Næste STEP</button>
                </div>
            </div>
        </section>
        <back-section :url="prevUrl" type="1"></back-section>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Info</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            Din levering vil blive opgraderet til en STEP PRIME levering.
                            Da din levering nu vil kræve 2 knivskarpe chauffører, betyder det at din leveringsdag rykkes.
                            Du adviseres altid med leveringsdatoen 2 dage i forvejen, samt et 4-timers interval for leveringen dagen før.
                            Forbered dig bedst muligt på din levering via vores kundeguide.
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary mb-1" data-dismiss="modal" @click="toggleModal">
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval || activeIframeModalInterval" class="modal-backdrop fade show"></div>

    </div>

</template>

<script>
import ProgressBar from "../reusable/ProgressBar.vue";
import BackSection from "../reusable/BackSection.vue";
import ModalIframe from "../reusable/ModalIframe.vue";
import FlashError from "../reusable/FlashError.vue";
import priceMixin from "../../../mixins/priceMixin";
import priceIntervalMixin from "../../../mixins/priceIntervalMixin";
import dateTimeMixin from "../../../mixins/dateTimeMixin";
import datePickerOptionsMixin from "../../../mixins/datePickerOptionsMixin";
import customerSmsFlowMixin from "../../../mixins/customerSmsFlowMixin";
import moment from "moment";
export default {
    name: "CmfPickupStep2",
    components: {FlashError, ProgressBar, BackSection, ModalIframe},
    mixins: [priceMixin, priceIntervalMixin, dateTimeMixin, datePickerOptionsMixin, customerSmsFlowMixin],
    props: {
        booking: {type: Object, required: true},
        configurations: {type: Object, required: true},
        nextUrl: {type: String, required: true},
        prevUrl: {type: String, required: true},
        applyChangesUrl: {type: String, required: true},
        additionalServiceShorterTimeInterval: {type: String, required: true},
        additionalServicesProp: {type: Object|Array, required: true},
        today: {type: String, required: true},
        tomorrow: {type: String, required: true},
        dayAfterTomorrow: {type: String, required: true},
        addOnShorterTimeInterval: {type: Object, required: false},
        shorterTimeIntervalPayedByClient: {type: Boolean, required: true},
        routeAvailableDays: {type: Object|Array, required: true},
        faqUrl: {type: String, required: true},
        serverNow: {type: String, required: true},
    },
    data() {
        return {
            activeIframeModalInterval: false,
            activeModalInterval: false,
            show: false,
            additionalServices: this.additionalServicesProp.length === undefined ? this.additionalServicesProp : {},
            shorterTimeIntervals: {},
            errors: {},
            priceIntervals: this.configurations.sms_flow_price_intervals_pickup && this.configurations.sms_flow_price_intervals_pickup.value
                ? JSON.parse(this.configurations.sms_flow_price_intervals_pickup.value)
                : [],
            currentSeconds: this.timeToSeconds(this.serverNow),
            serverSecondsAtMount: this.timeToSeconds(this.serverNow),
            mountTimestamp: 0,
            priceTimer: null,
        }
    },
    mounted() {
        this.mountTimestamp = Date.now();
        this.priceTimer = setInterval(() => {
            let elapsed = Math.floor((Date.now() - this.mountTimestamp) / 1000);
            this.currentSeconds = (this.serverSecondsAtMount + elapsed) % 86400;
        }, 1000);
    },
    beforeDestroy() {
        if (this.priceTimer) {
            clearInterval(this.priceTimer);
        }
    },
    computed: {
        priceMultiplier() {
            return this.getPriceIncreaseMultiplier(this.priceIntervals, Math.floor(this.currentSeconds / 60));
        },
        currentPercentage() {
            return this.getActivePriceIncreasePercentage(this.priceIntervals, Math.floor(this.currentSeconds / 60));
        },
        nextPriceBoundary() {
            return this.getNextPriceBoundary(this.priceIntervals, Math.floor(this.currentSeconds / 60));
        },
        upcomingPercentage() {
            return this.nextPriceBoundary ? this.nextPriceBoundary.upcomingPercentage : 0;
        },
        countdownVisible() {
            return this.nextPriceBoundary && this.upcomingPercentage > this.currentPercentage;
        },
        secondsUntilBoundary() {
            if (!this.nextPriceBoundary) {
                return 0;
            }
            let diff = this.nextPriceBoundary.boundaryMinutes * 60 - this.currentSeconds;
            if (diff <= 0) {
                diff += 86400;
            }
            return diff;
        },
        timeLeft() {
            return this.formatSecondsLeft(this.secondsUntilBoundary);
        },
    },
    created() {
        if (this.configurations.shorter_time_intervals_pickup) {
            let intervalMatchesRoute;

            if (this.addOnShorterTimeInterval) {
                this.shorterTimeIntervals = this.addOnShorterTimeInterval.configurations;
            } else {
                this.shorterTimeIntervals = JSON.parse(this.configurations.shorter_time_intervals_pickup.value);
            }

            let filteredTimeIntervals = [];
            for (let i in this.shorterTimeIntervals) {
                intervalMatchesRoute = true;
                if (Object.keys(this.routeAvailableDays).length) {
                    intervalMatchesRoute = false;
                    for (let r in this.routeAvailableDays) {
                        if (
                            (
                                this.routeAvailableDays[r]['from'] === '00:00' &&
                                this.routeAvailableDays[r]['to'] === '00:00'
                            ) ||
                            (
                                this.routeAvailableDays[r]['from'] <= this.shorterTimeIntervals[i]['from'] &&
                                this.routeAvailableDays[r]['to'] >= this.shorterTimeIntervals[i]['to']
                            )
                        ) {
                            intervalMatchesRoute = true;
                        }
                    }
                }

                if (!intervalMatchesRoute || this.shorterTimeIntervals[i]['option']) {
                    // Do nothing

                } else {
                    // Keep the raw base price; the time-of-day surcharge + VAT are applied
                    // live via displayPrice(). Payed-by-client intervals stay free.
                    let basePrice = this.shorterTimeIntervalPayedByClient ? 0 : this.shorterTimeIntervals[i].price;
                    this.$set(
                        this.shorterTimeIntervals[i],
                        'basePrice',
                        basePrice
                    );
                    filteredTimeIntervals.push(this.shorterTimeIntervals[i]);
                }
            }
            this.shorterTimeIntervals = filteredTimeIntervals;
        }

        if (!this.additionalServices[this.additionalServiceShorterTimeInterval]) {
            this.$set(this.additionalServices, this.additionalServiceShorterTimeInterval, {
                key: this.additionalServiceShorterTimeInterval,
                name: 'Kortere tidsinterval',
                value: '',
                price: 0,
                enabled: false
            });
        }
    },
    methods: {
        displayPrice(basePrice) {
            return this.calculatePriceWithVatAndRoundToNearestTens(basePrice * this.priceMultiplier);
        },
        validate() {
            this.errors = {};

            let arr = [this.additionalServiceShorterTimeInterval];

            for (let i = 0; i < arr.length; i++) {
                if (this.additionalServices[arr[i]] &&
                    this.additionalServices[arr[i]].enabled &&
                    !this.additionalServices[arr[i]].value
                ) {
                    this.$set(this.errors, arr[i], 'The value can\'t be empty');
                }
            }
        },
        goNext() {
            this.validate();
            let sti = this.additionalServices[this.additionalServiceShorterTimeInterval];
            if (sti && sti.value && sti.value.basePrice !== undefined) {
                this.$set(sti, 'basePrice', sti.value.basePrice);
                this.$set(sti, 'price', this.displayPrice(sti.value.basePrice));
            }
            setTimeout(() => {
                if (!Object.keys(this.errors).length) {
                    axios.post(this.applyChangesUrl, this.additionalServices)
                        .then((response) => {
                            window.location.href = this.nextUrl;

                        }).catch(error => {
                        this.$refs.flashError.flashError(error);
                    });
                }
            }, 50);

        },
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        onChangeShorterTimeInterval() {
            setTimeout(() => {
                let sti = this.additionalServices[this.additionalServiceShorterTimeInterval];
                if (sti['value'] && sti['value']['basePrice'] !== undefined) {
                    this.$set(sti, 'basePrice', sti['value']['basePrice']);
                    this.$set(sti, 'price', this.displayPrice(sti['value']['basePrice']));
                } else {
                    this.$set(sti, 'basePrice', 0);
                    this.$set(sti, 'price', 0);
                }
            }, 500);
        },
    },
}

</script>

<style scoped>

</style>
